import { Component } from '@angular/core';
import { LocalizationService } from '../../core/services/localization.service';
import { ActivatedRoute } from '@angular/router';
import { LocalizePipe } from '../../core/pipes/localization.pipe';

@Component({
    selector: 'app-success-page',
    imports: [LocalizePipe],
    templateUrl: './success-page.component.html'
})
export class SuccessPageComponent {
  message: string;

  constructor(
    private readonly _localizationService: LocalizationService,
    route: ActivatedRoute
  ) {
    this.message = route.snapshot.queryParams['message'];
    if (!this.message) {
      this.message = this._localizationService.localize(
        'TaskRespondedSuccessfully'
      );
    }
  }
}
